import {PROCESS_FILLED} from "./mock";
import APP_SETTINGS from "../../config/settings";

const DEFAULT_STATE = {
    processNumber: APP_SETTINGS.DEBUG ? PROCESS_FILLED.processNumber : '',
    process: APP_SETTINGS.DEBUG ? PROCESS_FILLED : null,
}

export default DEFAULT_STATE;